export enum shareCreationTrackingEvents {
  PP_POST_A_PROJECT_BANNER_CLICKED = 'Post a Project Banner CTA Clicked',
  PP_POST_A_PROJECT_MODAL_NO_OWNER = 'Post a Project Banner No Owner Viewed',
  PP_POST_A_PROJECT_IMAGE_UPLOADED = 'Post a Project Image Uploaded',
  PP_POST_A_PROJECT_SUBMITTED = 'Post a Project Form Submitted',
  PP_POST_A_PROJECT_FORM_ERROR = 'Post a Project Form Error',
  PP_POST_A_PROJECT_FORM_SUCCESS = 'Post a Project Form Success',
}
